import React, { useEffect, useState } from "react";
import {
  getCourseCategories,
  getCourses,
  addCutOffs,
  getCutOffsByCollege,
  getExam,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const entransExaminations = [
  {
    _id: "1",
    name: "JEE Advanced",
  },
  {
    _id: "2",
    name: "GATE",
  },
  {
    _id: "3",
    name: "CAT",
  },
  {
    _id: "4",
    name: "IIT JAM",
  },
];

const CollegeUniversityCutOffsStep2 = ({
  data,
  setData,
  setCurrentStep,
  currentStep,
}) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [courses, setCourses] = useState([]);
  const [formDataLoading, setFormDataLoading] = useState(false);

  // initial structure
  const initialItem = {
    round: 0,
    year: moment().year(),
    examName: "",
    topText: "",
    bottomText: "",
    extraHeading: "",
    courseCategoryId: "",
    coursesRank: [
      {
        courseId: "",
        openingRank: 0,
        closingRank: 0,
        seatType: "",
        gender: "",
      },
    ],
  };

  const initialItems = data?.cutoffData?.length
    ? data?.cutoffData
    : [initialItem];
  const [items, setItems] = useState(initialItems);

  // Fetch categories and courses once
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, courseRes, cutoffRes] = await Promise.all([
          getCourseCategories(),
          getCourses(),
          getCutOffsByCollege(data?._id),
        ]);
        setCategories(catRes?.data || []);
        console.log(
          "BGT63",
          cutoffRes?.data
            .slice() // copy so original is not mutated
            .sort((a, b) => {
              const examA = a.examName.toLowerCase();
              const examB = b.examName.toLowerCase();

              if (examA < examB) return -1;
              if (examA > examB) return 1;
              return a.round - b.round; // if same examName, then by round
            })
        );
        setItems(
          cutoffRes?.data.slice().sort((a, b) => {
            const examA = a.examName.toLowerCase();
            const examB = b.examName.toLowerCase();

            if (examA < examB) return -1;
            if (examA > examB) return 1;
            return a.round - b.round;
          })
        );

        setCourses(courseRes?.data || []);
      } catch (err) {
        console.error("Failed to fetch categories/courses:", err);
        toast.error("Failed to load dropdowns");
      }
    };
    fetchData();
  }, []);

  // Handle parent cutoff fields
  const handleMultiChange = (i, e) => {
    let newFormValues = [...items];
    newFormValues[i][e.target.name] =
      e.target.type === "number" ? parseInt(e.target.value) : e.target.value;
    setItems(newFormValues);
  };

  // Handle nested coursesRank fields
  const handleCourseChange = (i, j, e) => {
    let newFormValues = [...items];
    newFormValues[i].coursesRank[j][e.target.name] =
      e.target.type === "number" ? parseInt(e.target.value) : e.target.value;
    setItems(newFormValues);
  };

  const addItem = () => setItems([...items, initialItem]);

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
  };

  const addCourse = (i) => {
    let newFormValues = [...items];
    newFormValues[i].coursesRank.push({
      courseId: "",
      openingRank: 0,
      closingRank: 0,
      seatType: "",
      gender: "",
    });
    setItems(newFormValues);
  };

  const removeCourse = (i, j) => {
    let newFormValues = [...items];
    newFormValues[i].coursesRank.splice(j, 1);
    setItems(newFormValues);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setFormDataLoading(true);
      const payload = {
        collegeId: data?._id,
        cutoffData: items,
      };
      console.log("CDK123", payload);
      // return
      const res = await addCutOffs(payload);
      if (res?.status) {
        toast.success("Saved Successfully");
        setData({ ...data, cutoffData: items });
        // setCurrentStep(currentStep);
        navigate("/manage-college-university");
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
    } finally {
      setFormDataLoading(false);
    }
  };

  //// Examination /////
  const [examinations, setExaminations] = useState([]);

  const fetchExaminationations = async () => {
    try {
      const res = await getExam();
      console.log("fetched examinations", res?.data);
      if (res?.status) {
        setExaminations(res?.data);
      } else {
        toast.error("Error while Fetching Examinations Data");
      }
    } catch (error) {
      toast.error("failed to fetch Examinations Data");
      console.error("Error fetching Examinations Data:", error);
    }
  };

  useEffect(() => {
    fetchExaminationations();
  }, []);

  return (
    <section className="chartBox_area">
      <form onSubmit={handleUpdate}>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12 mt-3">
            <label>
              Examination with round
              <button
                className="btn btn-sm btn-success ms-2"
                type="button"
                onClick={addItem}
                style={{ marginLeft: "15px" }}
              >
                <i className="fas fa-plus"></i> Add
              </button>
            </label>

            {items.map((element, index) => (
              <div
                className="border rounded p-3 mb-3"
                key={index}
                style={{
                  // padding:"10px",
                  background: "#f9f9f9f9",
                }}
              >
                {/* Round + Year */}
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <label>Course Category</label>
                    <select
                      className="form-control"
                      name="courseCategoryId"
                      value={element.courseCategoryId}
                      onChange={(e) => handleMultiChange(index, e)}
                    >
                      <option value="">-- Select Category --</option>
                      {categories.map((cat) => (
                        <option key={cat._id} value={cat._id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-5 mb-2">
                    <label>Exam Name</label>
                    {/* <input
                      type="text"
                      className="form-control"
                      name="examName"
                      value={element.examName}
                      onChange={(e) => handleMultiChange(index, e)}
                    /> */}
                    <select
                      className="form-control"
                      name="examName"
                      value={element.examName}
                      onChange={(e) => handleMultiChange(index, e)}
                    >
                      <option value="">-- Select Exam --</option>
                      {examinations?.length == 0 ? (
                        <option>No Examination Found</option>
                      ) : (
                        examinations.map((exam) => (
                          <option key={exam._id} value={exam._id}>
                            {exam.name}
                          </option>
                        ))
                      )}
                    </select>
                  </div>

                  <div className="col-md-2 mb-2">
                    <label>Round</label>
                    <input
                      type="number"
                      className="form-control"
                      name="round"
                      value={element.round}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>
                  <div className="col-md-2 mb-2">
                    <label>Year</label>
                    <input
                      type="number"
                      className="form-control"
                      name="year"
                      value={element.year}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>
                </div>

                {/* Text Fields */}
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <label>Extra Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      name="extraHeading"
                      value={element.extraHeading}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label>Top Text</label>
                    <textarea
                      className="form-control"
                      name="topText"
                      value={element.topText}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label>Bottom Text</label>
                    <textarea
                      className="form-control"
                      name="bottomText"
                      value={element.bottomText}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>
                </div>

                {/* Courses Rank */}
                <div className="mt-3">
                  <label>
                    Courses Rank
                    <button
                      className="btn btn-sm btn-primary ms-2"
                      type="button"
                      onClick={() => addCourse(index)}
                    >
                      <i className="fas fa-plus"></i> Add Course
                    </button>
                  </label>
                  {element.coursesRank.map((course, j) => (
                    <div
                      className="row border p-2 mt-2"
                      key={j}
                      style={{
                        margin: "5px",
                        background: "#fff",
                      }}
                    >
                      <div className="col-md-3">
                        <label>Course</label>
                        <select
                          className="form-control"
                          name="courseId"
                          value={course.courseId}
                          onChange={(e) => handleCourseChange(index, j, e)}
                        >
                          <option value="">-- Select Course --</option>
                          {courses
                            .filter(
                              (i) => i.categoryId === element?.courseCategoryId
                            )
                            .map((c) => (
                              <option key={c._id} value={c._id}>
                                {c.degreeName}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label>Opening Rank</label>
                        <input
                          type="number"
                          className="form-control"
                          name="openingRank"
                          value={course.openingRank}
                          onChange={(e) => handleCourseChange(index, j, e)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label>Closing Rank</label>
                        <input
                          type="number"
                          className="form-control"
                          name="closingRank"
                          value={course.closingRank}
                          onChange={(e) => handleCourseChange(index, j, e)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label>Seat Type</label>
                        <input
                          type="text"
                          className="form-control"
                          name="seatType"
                          value={course.seatType}
                          onChange={(e) => handleCourseChange(index, j, e)}
                        />
                      </div>
                      <div className="col-md-2">
                        <label>Gender</label>
                        <input
                          type="text"
                          className="form-control"
                          name="gender"
                          value={course.gender}
                          onChange={(e) => handleCourseChange(index, j, e)}
                        />
                      </div>
                      {j > 0 && (
                        <div className="col-md-1 d-flex align-items-center">
                          <i
                            className="fas fa-times text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={() => removeCourse(index, j)}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Remove Round */}
                {index > 0 && (
                  <div className="text-end">
                    <i
                      className="fas fa-times text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => removeProducts(index)}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-end">
          {currentStep > 1 && (
            <button
              type="button"
              className="btn mt-3 me-2"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
                marginRight: "15px",
              }}
              onClick={() => setCurrentStep(currentStep - 1)}
            >
              Back
            </button>
          )}
          <button
            disabled={formDataLoading}
            type="submit"
            className="btn mt-3"
            style={{ background: "rgb(133, 218, 79)", borderRadius: "13px" }}
          >
            {formDataLoading ? "Saving..." : "Save & Continue"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default CollegeUniversityCutOffsStep2;
